<template>
    <div id="mainPage">
        <el-container class="contentBox imgContent">
            <div @click="logout" class="logout">
                注销
            </div>
            <el-header>
                <div class="main-header-box">
                    <div class="main-header-right-box">
                        <img src="../../../static/img/touxiangkaobei5.png" alt="">
                    </div>
                    <div class="main-header-left-box">
                        <div>{{data.nikiName}}</div>
                        <div class="names" style="margin-top: 15px">角色：{{data.roleList[0].roleName}}</div>
                        <div class="names" v-if="data.experience !== null">经验：{{data.experience}}</div>
                        <div class="names" v-else>经验：0</div>
                    </div>
                </div>
            </el-header>
            <el-container class="containMain">
                <div class="leftMain">
                    <div class="role-box">
                        <img v-if="data.sex == 2" style="width: 310px;height: 553px;" src="../../../static/img/nvjuese.png" alt="">
                        <img src="../../../static/img/nanjuese.png"  v-else  alt="">
                    </div>
                    <div style="width: 150px;margin:-40px auto" v-if="data.roleList[0].roleName === '老师'">
                        <el-dropdown @command="handleCommand">
                            <el-button type="primary">
                                管理员专属功能<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="one">实验报告审批</el-dropdown-item>
                                <el-dropdown-item command="two">精灵助手完善</el-dropdown-item>
                                <el-dropdown-item command="three">法律法规</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <el-container class="rightMain">
                    <div class="rightContent">
                        <ul class="contTop">
                            <li>
                                <div class="newModel" @mouseover="addHover" @click="routerPush(3)">
                                    <img :src="images" alt="">
                                </div>
                            </li>
                            <li>
                                <div class="assessment" @click="routerPush(5)" ></div>
                            </li>
                        </ul>
                        <div class="contBottom">
                            <ul>
                                <li>
                                    <div class="same dataCent"  @click="routerPush(2)"></div>
                                </li>
                                <li>
                                    <div class="same knowledge" @click="routerPush(1)"></div>
                                </li>
                                <li>
                                    <div class="lonees" @click="routerPush(0)"></div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </el-container>
            </el-container>
            <div class="bottomLog">
                <div class="bottomLogBox"><img src="../../../static/img/Task.png" alt=""></div>
                <div class="bottomLogBox"><img src="../../../static/img/Bag.png" alt=""></div>
                <div class="bottomLogBox">
                    <img @click="roleClick" src="../../../static/img/Role.png" alt="">
                    <role class="role" v-if="roleDialog"></role>
                </div>
            </div>
        </el-container>
    </div>
</template>
<script>
	import logout from '@/components/logOut/logOut.vue'
	import role from '@/components/role/role.vue'
	export default {
		name: "index",
		data() {
			return {
				images:'../../../static/img/img11.png',
				dialogVisible: false,
				roleDialog: false,
				data: {
					roleList: [{roleName: '老师'}]
				}
			}
		},
		components: {
			logout,
			role,
		},
		methods: {
			//注销账号接口
			logout() {
				this.$axios.get(this.URL.logOut).then(res => {
					if (res.status === 200) {

						localStorage.removeItem('TOKEN');
						sessionStorage.removeItem('command');
						this.$notify({
							title: '成功',
							message: '注销账号成功',
							type: 'success',
						});
						this.goMain('/login')
					}
				})
			},
			leaveHover(){
				this.images = '../../../static/img/img1.png'
			},
			close(){
				this.dialogVisible = false;
				this.$store.state.login = false;

			},
			handleCommand(command) {
				sessionStorage.setItem('command', command)
				this.goMain('/audit')
			},
			//助手弹窗
			roleClick() {
				this.roleDialog = !this.roleDialog
			},
			//获取个人信息
			getData() {
				this.$axios.get(this.URL.info).then(res => {
					console.log(res);
					if (res.status === 200) {
						sessionStorage.setItem('userData', JSON.stringify(res.data))
						this.data = res.data
					}
				})
			},
			routerPush(index) {
				let path = ''
				if (index === 1) {
					path = '/knowledge'
				} else if (index === 2) {
					path = '/dataCenter'
				} else if (index === 5) {
					path = '/assessment'
				} else if (index === 4) {
					path = '/shop'
				} else if (index === 0){
					path='/practice'
				}else{
					// path='/webgl'
                    window.open('http://uav.cnuvr.cn/model')
                    return ;
				}
				this.goMain(path)
			},

			//第一次登陆弹出的提示
			jumpPrompt(){
				let login = this.$store.state.login
				if(login){
					this.dialogVisible = true
				}else{
					this.dialogVisible = false
				}
			},
			addHover(){
				this.images = '../../../static/img/img11.png'
			},
		},
		created() {
			this.jumpPrompt()
			this.getData()
		},
		mounted(){

		}
	}
</script>

<style lang="less" scoped>
    #mainPage{
        overflow: hidden;
        position: absolute;
        width: 100%;
        z-index: 999;
        .contentBox {
            background: url("../../../static/img/min.png") no-repeat;
            background-size: cover;
            .logout {
                font-weight: 700;
                font-size: 14px;
                color: #ffffff;
                position: absolute;
                z-index: 9999;
                right: 3%;
                top: 10px;
                cursor: pointer;
            }
            img {
                width: 100%;
            }
            .el-header{
                min-height: 114px;
                padding: 0;
                position: relative;
                .main-header-box{
                    position: absolute;
                    right: 10.3%;
                    display: flex;
                    .main-header-left-box {
                        margin-left: -240px;
                        margin-top: 15px;
                        font-size: 12px;
                        .names{
                            font-size: 14px;
                            color:#6985b5;
                        }
                        :first-child {
                            font-size: 20px;
                            font-weight: bold;
                            color: #ffffff;
                            height: 30px;
                        }
                    }
                    img {
                        width: 100%;
                    }
                }
            }
        }
        .el-container{
            .containMain{
                width: 100%;
                .leftMain{
                    position: relative;
                    width: 20%;
                    .role-box{
                        width: 16%;
                        position: fixed;
                        bottom: 5vh;
                        left: 3%;
                    }
                }
                .rightMain{
                    width: 80%;
                    .rightContent{
                        width: 100%;
                        .contTop{
                            height: 44vh;
                            display: flex;
                            li{
                                width: 50%;
                                .newModel{
                                    cursor: pointer;
                                    width: 35%;
                                    margin: 0 auto;
                                    height: 38vh;
                                    animation-name:myfirst;
                                    animation-duration:0.7s;
                                    animation-iteration-count:infinite;//动画次数
                                    animation-direction:alternate;
                                    animation-play-state:running;
                                }
                                @-webkit-keyframes myfirst {
                                    0% {
                                        width: 35%;
                                    }
                                    100% {
                                        width: 37%;
                                    }
                                }
                                .newModel:hover{
                                    -webkit-animation-name:none
                                }
                                .assessment{
                                    cursor: pointer;
                                    width: 30%;
                                    background: url("../../../static/img/img2.png") no-repeat;
                                    height: 100%;
                                    background-size: 100%;
                                    height: 40vh;
                                }
                                .assessment:hover{
                                    cursor: pointer;
                                    width: 33%;
                                    background: url("../../../static/img/img12.png") no-repeat;
                                    height: 100%;
                                    background-size: 100%;
                                    /*margin-left: -1%;*/
                                }
                            }
                        }
                        .contBottom{
                            height: 40vh;
                            ul{
                                display: flex;
                                height: 100%;
                                li{
                                    width: 33.33%;
                                    .same{
                                        /*width: 42%;*/
                                        /*margin-left: 4%;*/
                                    }
                                    .dataCent{
                                        cursor: pointer;
                                        background: url("../../../static/img/img3.png") no-repeat;
                                        height: 100%;
                                        background-size: 100%;
                                        width: 42%;
                                        margin-left: 4%;
                                        height: 37vh;
                                    }
                                    .dataCent:hover{
                                        cursor: pointer;
                                        background: url("../../../static/img/img13.png") no-repeat;
                                        height: 100%;
                                        background-size: 100%;
                                        margin-top: -3vh;
                                        width: 55%;
                                        margin-left: 0%;
                                        height: 37vh;
                                    }
                                    .knowledge{
                                        width: 42%;
                                        margin-left: 4%;
                                        cursor: pointer;
                                        background: url("../../../static/img/img4.png") no-repeat;
                                        height: 100%;
                                        background-size: 100%;
                                        height: 30vh;
                                    }
                                    .knowledge:hover{
                                        cursor: pointer;
                                        background: url("../../../static/img/img14.png") no-repeat;
                                        height: 100%;
                                        background-size: 100%;
                                        width: 55%;
                                        margin-left: 0%;
                                        margin-top: -3vh;
                                        height: 37vh;
                                    }
                                    .lonees{
                                        width: 42%;
                                        cursor: pointer;
                                        background: url("../../../static/img/img15.png") no-repeat;
                                        height: 100%;
                                        background-size: 100%;
                                        height: 31vh;
                                    }
                                    .lonees:hover{
                                        width: 58%;
                                        margin-left: -3%;
                                        margin-top: -3vh;
                                        cursor: pointer;
                                        background: url("../../../static/img/img5.png") no-repeat;
                                        height: 100%;
                                        background-size: 100%;
                                        height: 38vh;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .main-title-img {
        width: 300px;
        position: relative;
        color: #ffffff;
        .main-title-img-title {
            font-size: 16px;
            position: absolute;
            left: 120px;
            top: 41%;
        }
    }

    .main-img {
        width: 160px;
        position: absolute;
        top: 59px;
        left: 63px;
        .img {
            width: 100%;
        }
    }

    .list-img {
        position: relative;
    }

    .el-footer {
        color: #333;
        text-align: center;
        line-height: 60px;
    }

    .el-aside {
        color: #333;
        text-align: center;
        line-height: 200px;
    }

    .el-main {
        color: #333;
        text-align: center;
    }

    .list-img-box {
        display: flex;
        position: relative;
        margin-left: 20%;
        width: 80%;
        .list-img {
            width: 33.3333%;
        }
    }

    .bottomLog {
        position: fixed;
        display: flex;
        margin-left: 40%;
        bottom: 0;
        width: 20%;
        .bottomLogBox {
            width: 33.33%;
            img {
                width: 100%;
            }
        }
    }

    .role {
        position: absolute;
        bottom: 0;
        left: 450px;
    }
    .cece{
        position: absolute;
        width: 80px;
        padding:20px 0;
        border-radius:3px;
        left: -45px;
        top: 50px;
        color: #ffff66;
        font-size: 18px;
        font-weight: 800;
        font-family: helvetica,arial,sans-serif;
        text-align: center;
        text-shadow:0 0 0.2em #f87,
            -0 -0 0.2em #f87;
        -webkit-transition: all 1.5s ease;
        transition: all 1.5s ease;
        -webkit-animation-timing-function:ease-in-out;
        -webkit-animation-name:breathe;
        -webkit-animation-duration:2700ms;
        -webkit-animation-iteration-count:infinite;
        -webkit-animation-direction:alternate;

    }
    @-webkit-keyframes breathe {
        30% {
            opacity:.7;
            box-shadow:0 1px 2px rgba(255,255,255,0.1);
        }
        100% {
            opacity:1;

            box-shadow:0 1px 30px #ffff66;;
        }
    }
    .ale{
        position: absolute;
        width: 80px;
        padding:20px 0;
        border-radius:3px;
        left: 300px;
        top: 400px;
        color: #ffff66;
        font-size: 18px;
        font-weight: 800;
        font-family: helvetica,arial,sans-serif;
        text-align: center;
    }



</style>



// WEBPACK FOOTER //
// src/views/main/index.vue